import { useMemo } from 'react';
import type { PlayerFields } from '@/api/common';
import { useGetCommonStore } from '@/store';

export const useStateOptions = (states: PlayerFields | null) => {
  const useCommonStore = useGetCommonStore();
  const user = useCommonStore.use.user();

  const statesOptions = useMemo(() => {
    if (user?.state) {
      return [
        {
          name: user.state,
          value: user.state,
        },
      ];
    }

    if (!states) return [];
    const { fields } = states;

    return fields
      ?.find((item) => item.field === 'state')
      ?.inclusion?.in.map((state: string) => ({
        name: state,
        value: state,
      }));
  }, [user, states]);

  const requiresState = useMemo(
    () => !!(user?.state || statesOptions?.length),
    [user?.state, statesOptions]
  );

  return { statesOptions, requiresState };
};
